import { getIsNav4UserOptOut } from '@atlassian/jira-navigation-apps-sidebar-nav4-get-user-meta/src/index.tsx';
import type { Nav4RolloutEap } from '../../../types.tsx';

export const getNav4RolloutForEap = (): Nav4RolloutEap => ({
	stage: 'eap',
	isUserOptOut: getIsNav4UserOptOut(),
});
